import React, { useEffect, useState } from 'react';
import { Loader } from '../../../../Common';
import SelectBenefit from './Components/SelectBenefit';
import SelectVendor from './Components/SelectVendor';
import { useDispatch, useSelector } from 'react-redux';
import SelectAirport from './Components/SelectAirport';
import SelectZone from './Components/SelectZone';
import UploadVendorPricing from './Components/UploadVendorPricing';
import AddVendorPricing from './Components/AddVendorPricing';
import SelectProjects from './Components/SelectProjects';
import ConfigurationChecklist from './Components/ConfigurationCheckList';
import queryString from 'query-string';
import {
  GET_LIVE_CONFIG,
  GET_LIVE_CONFIG_EMPTY,
  GET_ONBOARDING_CONFIGURATION,
  GET_ONBOARDING_CONFIGURATION_EMPTY,
  SAVE_DRAFT_CONFIGURATION_EMPTY,
  UPDATE_DRAFT_CONFIGURATION_EMPTY,
} from '../../../../../store/actions';

const getInitialValues = () => {
  return {
    benefit: {
      name: 'Airport Transfer',
    },
    multiProjects: [],
    vendorPricing: {
      vendors: [],
      airports: [],
      pricingDetails: [],
    },
    version: null,
  };
};

const VendorOnboarding = () => {
  const dispatch = useDispatch();

  const { id = '' } = queryString.parse(location.search);

  const [state, setState] = useState(getInitialValues());
  const [formCount, setFormCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isDraftConfiguration, setIsDraftConfiguration] = useState(false);
  const [configuration, setConfiguration] = useState(null);
  const [fetchLiveConfigData, setFetchLiveConfigData] = useState(null);

  const {
    saveDraftConfiguration,
    saveDraftConfigurationLoading,
    updateDraftConfiguration,
    updateDraftConfigurationLoading,
    downloadPriceTypeLoading,
    getOnboardingConfiguration,
    getOnboardingConfigurationLoading,
    getLiveConfig,
    getLiveConfigLoading,
    getVendorLoading,
    getProjectLoading,
  } = useSelector((state: any) => ({
    saveDraftConfiguration: state.SaveDraftConfiguration.data,
    saveDraftConfigurationLoading: state.SaveDraftConfiguration.loading,

    updateDraftConfiguration: state.UpdateDraftConfiguration.data,
    updateDraftConfigurationLoading: state.UpdateDraftConfiguration.loading,

    downloadPriceType: state.DownloadPriceType.data,
    downloadPriceTypeLoading: state.DownloadPriceType.loading,

    getOnboardingConfiguration: state.GetOnboardingConfiguration.data,
    getOnboardingConfigurationLoading: state.GetOnboardingConfiguration.loading,

    getLiveConfig: state.GetLiveConfig.data,
    getLiveConfigLoading: state.GetLiveConfig.loading,

    getVendorLoading: state.GetVendorList?.loading,
    getProjectLoading: state.GetProjectV2.loading,
  }));

  useEffect(() => {
    if (id) {
      dispatch({
        type: GET_ONBOARDING_CONFIGURATION,
        payload: {
          id: id,
        },
      });
    }
  }, [id]);

  useEffect(() => {
    if (getOnboardingConfiguration !== null) {
      setState({
        multiProjects: getOnboardingConfiguration?.results?.configuration_data?.multiProjects,
        vendorPricing: {
          airports: getOnboardingConfiguration?.results?.configuration_data?.vendorPricing?.airports ?? [],
          vendors: getOnboardingConfiguration?.results?.configuration_data?.vendorPricing?.vendors ?? [],
          pricingDetails: getOnboardingConfiguration?.results?.configuration_data?.vendorPricing?.pricingDetails ?? [],
        },
        version: getOnboardingConfiguration?.results?.version,
      });
      setFormCount(
        getOnboardingConfiguration?.results?.configuration_data?.page == 0 ? 8 : getOnboardingConfiguration?.results?.configuration_data?.page ?? '1',
      );
      setConfiguration(getOnboardingConfiguration?.results);
      setIsDraftConfiguration(true);
      dispatch({
        type: GET_ONBOARDING_CONFIGURATION_EMPTY,
      });
    }
  }, [getOnboardingConfiguration]);

  useEffect(() => {
    return () => {
      setState(getInitialValues());
    };
  }, []);

  useEffect(() => {
    if (saveDraftConfiguration !== null) {
      setIsDraftConfiguration(true);
      setFormCount((prev: number) => prev + 1);
      setConfiguration(saveDraftConfiguration?.results);
      dispatch({
        type: SAVE_DRAFT_CONFIGURATION_EMPTY,
      });
    }
  }, [saveDraftConfiguration]);

  useEffect(() => {
    if (updateDraftConfiguration !== null) {
      setFormCount((prev: number) => prev + 1);
      dispatch({
        type: UPDATE_DRAFT_CONFIGURATION_EMPTY,
      });
    }
  }, [updateDraftConfiguration]);

  useEffect(() => {
    if (
      getProjectLoading ||
      saveDraftConfigurationLoading ||
      updateDraftConfigurationLoading ||
      downloadPriceTypeLoading ||
      getOnboardingConfigurationLoading ||
      getLiveConfigLoading ||
      getVendorLoading
    ) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [
    getProjectLoading,
    saveDraftConfigurationLoading,
    updateDraftConfigurationLoading,
    downloadPriceTypeLoading,
    getOnboardingConfigurationLoading,
    getLiveConfigLoading,
    getProjectLoading,
    getVendorLoading,
  ]);

  useEffect(() => {
    if (formCount === 3) {
      if (fetchLiveConfigData === null) {
        dispatch({
          type: GET_LIVE_CONFIG,
          payload: {
            urlParams: {
              vendorId: state.vendorPricing?.vendors?.[0]?.id,
              benefitType: 'Airport Transfer',
              configurationType: 'vendor_onboarding',
            },
          },
        });
      }
    }
  }, [formCount]);

  useEffect(() => {
    if (getLiveConfig !== null) {
      console.log('check here', getLiveConfig?.results?.configuration_data);
      if (getLiveConfig?.results?.configuration_data) {
        setState(prev => ({
          ...prev,
          ...getLiveConfig.results.configuration_data,
        }));
        setFetchLiveConfigData(getLiveConfig?.results?.configuration_data ?? null);
      }
      dispatch({
        type: GET_LIVE_CONFIG_EMPTY,
      });
    }
  }, [getLiveConfig]);

  return (
    <div>
      {loading && <Loader />}
      {formCount === 1 && <SelectBenefit state={state} setState={setState} setFormCount={setFormCount} />}
      {formCount === 2 && <SelectVendor state={state} setState={setState} setFormCount={setFormCount} />}
      {formCount === 3 && (
        <SelectAirport
          state={state}
          setState={setState}
          setFormCount={setFormCount}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
        />
      )}
      {formCount === 4 && (
        <SelectZone
          setState={setState}
          setFormCount={setFormCount}
          state={state}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
        />
      )}
      {formCount === 5 && <UploadVendorPricing setState={setState} setFormCount={setFormCount} state={state} />}
      {formCount === 6 && (
        <AddVendorPricing
          state={state}
          setState={setState}
          setFormCount={setFormCount}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
        />
      )}
      {formCount === 7 && <SelectProjects state={state} setState={setState} setFormCount={setFormCount} />}
      {formCount === 8 && (
        <ConfigurationChecklist
          state={state}
          setFormCount={setFormCount}
          configuration={configuration}
          isDraftConfiguration={isDraftConfiguration}
          fetchLiveConfigData={fetchLiveConfigData}
        />
      )}
    </div>
  );
};

export default VendorOnboarding;
